/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForWorkloadResourceSnapshot extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForWorkloadResourceSnapshot");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForWorkloadResourceSnapshot.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForWorkloadResourceSnapshot>): BackgroundJobPayloadForWorkloadResourceSnapshot {
        let obj = Object.assign(new BackgroundJobPayloadForWorkloadResourceSnapshot(), model);
        BackgroundJobPayloadForWorkloadResourceSnapshot.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForWorkloadResourceSnapshot>): BackgroundJobPayloadForWorkloadResourceSnapshot {
        if (!model) return null;
        return BackgroundJobPayloadForWorkloadResourceSnapshot.newInstance(<BackgroundJobPayloadForWorkloadResourceSnapshot> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForWorkloadResourceSnapshot) {
        if (!obj) return;

        models.BackgroundJobPayloadForWorkloadResourceSnapshot.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForWorkloadResourceSnapshot): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForWorkloadResourceSnapshot.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

}
